import { CustomerAddress } from "./customer-address";

export class Customer {
    id:number = 0;
    name:string = '';
    comercial_name:string = '';
    rfc:string = '';
    street:string = '';
    colony:string = '';
    zip_code:number = 0;
    locality:string = '';
    state:string = '';
    account_number:string = '';
    phone_number:string = '';
    email:string = '';
    active:boolean = true;
    type:string = '';
    directions:CustomerAddress[] = [];
    contact:string = '';
    contact_email:string = '';
}
